import React from "react";
import PropTypes from "prop-types";

import LocalNewsService from "services/LocalNewsService";

import LocalNewsDropdown from "./LocalNewsDropdown";

class LocalNews extends React.Component {
  static propTypes = {
    settings: PropTypes.object,
  };

  static defaultProps = {
    settings: {},
  };

  constructor(props) {
    super(props);

    this.state = {
      location: LocalNewsService.getSavedLocation() || {},
    };
  }

  setLocation = (location) => {
    this.setState({
      location,
    });

    if (location && location.url) {
      window.location = location.url;
    }
  };

  render = () => {
    const { location } = this.state;

    const { settings } = this.props;

    return [
      <h3 className="navigation-title" key="local-news-heading">
        <a href={location.url} className="navigation-title__link">
          {settings.title} {location.text}
          <svg className="navigation-title__chevron" width="7px" height="14px">
            <use width="7px" height="14px" xlinkHref="#chevron-right" />
          </svg>
        </a>
      </h3>,
      <p key="local-news-prefix">{settings.dropdownPrefix}</p>,
      <LocalNewsDropdown
        key="local-news-dropdown"
        location={location}
        setLocation={this.setLocation}
        settings={settings}
      />,
    ];
  };
}

export default LocalNews;
